import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProjects } from '../services/webService';
import { translate } from '../utils/translations';
import { stripHtml } from '../utils/stripHtml';
import './Home.css';

function Home() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const allProjects = getProjects();
    let copyArray = allProjects.slice();
    copyArray.sort(function (a, b) {
      if (a.orderPublish < b.orderPublish) return -1;
      else if (a.orderPublish > b.orderPublish) return 1;
      else return 0;
    });
    let i = 0;
    const lastProjects = [];
    copyArray.reverse().forEach(item => {
      if (i <= 5) lastProjects.push(item);
      i++;
    });
    setProjects(lastProjects);
  }, []);

  return (
    <div className="container-custom">
      <br /><br />
      <div className="jumbotron bg-light p-5 rounded">
        <h1 className="display-4">{translate('Title')}</h1>
        <p className="lead">
          {translate('Intro')}
        </p>
        <hr className="my-4" />
        <p className="text-muted">
          <i className="fas fa-robot"></i> IA &nbsp;&nbsp;
          <i className="fas fa-globe"></i> Web &nbsp;&nbsp;
          <i className="fas fa-mobile-alt"></i> Móvil &nbsp;&nbsp;
          <i className="fas fa-gamepad"></i> Juegos
        </p>
      </div>
      <br />

      <div className="row">
        <div className="col-lg-12">
          <h2 className="page-header">{translate('last_projects')}</h2>
        </div>
        <div className="album py-5 bg-light">
          <div className="container">
            <div className="row">
              <div className="col-lg-12"></div>
              <div className="d-flex flex-wrap justify-content-center" style={{ gap: '20px' }}>
                {projects.map(project => (
                  <div key={project.id} className="card shadow-sm" style={{ flex: '1 1 calc(30% - 50px)', maxWidth: '350px', minWidth: '280px' }}>
                    <Link to={`/project/${project.id}`}>
                      <img src={project.banner} alt="" className="card-img-top" style={{ height: '200px', objectFit: 'cover' }} />
                    </Link>
                    <div className="card-body">
                      <Link to={`/project/${project.id}`} className="text-decoration-none">
                        <h5 className="card-title">{translate(project.name)}</h5>
                      </Link>
                      <p className="card-text text-muted small">
                        {stripHtml(translate(project.description)).substring(0, 120)}
                        {stripHtml(translate(project.description)).length > 120 ? '...' : ''}
                      </p>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="btn-group">
                          <Link to={`/project/${project.id}`} className="btn btn-sm btn-outline-primary">
                            <i className="fas fa-info-circle"></i> Ver más
                          </Link>
                        </div>
                        <small className="text-muted">
                          {project.id === 13 || project.id === 14 || project.id === 15 ? (
                            <span className="badge badge-primary">IA</span>
                          ) : project.isApplication ? (
                            <span className="badge badge-info">App</span>
                          ) : (
                            <span className="badge badge-success">Juego</span>
                          )}
                        </small>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
